import { ofType } from "redux-observable";
import * as RxOp from "rxjs/operators";

import { requestPaginatedSearch } from "@/components/transactionSearchPage/TransactionSearchPage.state";
import {
  PAGE_NEXT,
  PAGE_PREVIOUS,
  SET_CURRENT_PAGE,
  getCurrentPage,
  getIsClientPaginated,
} from "./TransactionSearchResults.state";

const SearchOnPageChangeEpic = (action$, state$) =>
  action$.pipe(
    ofType(PAGE_NEXT, PAGE_PREVIOUS, SET_CURRENT_PAGE),
    // A client-paged set already holds every row; re-requesting would re-fetch
    // and re-filter the whole thing again and reset the page back to 1
    RxOp.filter(() => !getIsClientPaginated(state$.value)),
    RxOp.map(() => requestPaginatedSearch({ page: getCurrentPage(state$.value) })),
    RxOp.catchError((e) => console.error(e))
  );

export default SearchOnPageChangeEpic;
